module.exports = __webpack_public_path__ + "static/media/Purrloin_gaussian2.2ba92c20.png";